import { useEffect, useState, useCallback } from 'react';

export const useV4Capabilities = (api) => {
  const [catalog, setCatalog] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setError(false);
    api.get('/api/voice/model-capabilities', { signal: controller.signal }).then(({ data }) => {
      if (!controller.signal.aborted) setCatalog(data);
    }).catch(() => { if (!controller.signal.aborted) setError(true); });
    return () => controller.abort();
  }, [api, attempt]);
  const retry = useCallback(() => setAttempt(n => n + 1), []);
  return { catalog, error, retry };
};